import { Component, OnDestroy, OnInit } from "@angular/core";
import { ToastService } from "../../../shared/toast.service";
import { TriggerInitialLoadDTO } from "src/app/shared/Models/write/TriggerInitialLoadDTO";
import { AdminPanelTriggerInitialLoadService } from "src/app/shared/services/admin-panel-trigger-initial-load-service";
import { Subject } from "rxjs";
import { first } from "rxjs/operators";
import { FormControl, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-admin-panel-trigger-initial-load",
  templateUrl: "./admin-panel-trigger-initial-load.component.html",
  styleUrls: ["./admin-panel-trigger-initial-load.component.scss"],
  providers: [ToastService],
})
export class AdminPanelTriggerInitialLoadComponent
  implements OnDestroy, OnInit
{
  initialLoadUploadForm: FormGroup;
  uploadErrors: string;
  fileToUpload: File | any;

  constructor(
    private _adminPanelTriggerInitialLoadService: AdminPanelTriggerInitialLoadService,
    private _toastService: ToastService
  ) {}
  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngOnInit() {
    this.initialLoadUploadForm = new FormGroup({
      fileToUpload: new FormControl("", [Validators.required]),
    });
  }

  selectFile(e: any) {
    this.fileToUpload = e.target.files[0];
    this.uploadErrors = "";
  }
  sendInitialLoadTrigger() {
    this._adminPanelTriggerInitialLoadService
      .triggerInitialLoad(this.fileToUpload)
      .then(() => {
        this._toastService.showSuccesToast(
          $localize`:@@admin.initial.load.triggered:Initial load has been triggered`,
          $localize`:@@general.initial.load:Initial load`
        );
        this.fileToUpload = null;
        this.initialLoadUploadForm.get("fileToUpload")?.reset();
      })
      .catch((error) => {
        this.uploadErrors = error?.error?.detailedError?.message;

        this._toastService.showErrorToast(
          $localize`:@@validation.somethingwhentwrong:Something went wrong!`,
          $localize`:@@admin.initial.load.somethingswrongelaborated:Somethng went wrong when triggering the initial load!`
        );
      });
  }
}
